import { Franchise } from "./franchise.model";

export interface Lender {
    Title: string,
    FID: number,
    LenderID: number,
    latestBinder?: Date,
    binderCount?: number,
    isCash?: boolean
    LenderContacts?: LenderContact[]
}

export class LenderContact {
    LenderID: number;
    addressNumber: String;
    addressState: String
    addressZip: number;
    addressCity: String;
    contactFirstName: String;
    contactLastName: String;
    contactPhone: number;
    contactEmail: String;
    contactId: number;
    FID: number;
    Franchises: Franchise[]

    constructor(lenderId?:number) {
        this.LenderID = lenderId || 0;
        this.addressNumber = '';
        this.addressState = '';
        this.addressZip = 0;
        this.addressCity = '';
        this.contactFirstName = '';
        this.contactLastName = '';
        this.contactPhone = 0;
        this.contactEmail = '';
        this.contactId = 0;
        this.FID = 0;
        this.Franchises = [];
    }
}
export class DrawSchedule {
    Title: string;
    LenderID: number;
    FID: number;
    ScheduleID: number;
    isCash: boolean;
    Deleted: string;
    Draws: Draw[]

    constructor() {
        this.Title = '';
        this.LenderID = 0;
        this.FID = 0;
        this.ScheduleID = 0;
        this.isCash = false;
        this.Deleted = '';
        this.Draws = [];
    }
}

export class Draw {
    ScheduleID: number;
    Percentage: number;
    Title: string;
    DrawID: number;
    CorpPayment: number;
    CashVerbiage: number;

    constructor(percentage?: number, event?: string) {
        this.ScheduleID = 0;
        this.Percentage = percentage || 0;
        this.Title = event || '';
        this.DrawID = 0;
        this.CorpPayment = 0;
        this.CashVerbiage = 0;
    }
}